/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import moment from 'moment-timezone';

import {
  TablePagination,
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Paper,
  Tooltip,
} from '@material-ui/core';

import { GetApp } from '@material-ui/icons';

function createData(nf, order, value, client, receiving, emit) {
  return {
    nf,
    order,
    value,
    client,
    receiving,
    emit,
  };
}

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
  table: {
    minWidth: 1100,
  },
});

const StyledTableCell = withStyles(() => ({
  head: {
    // backgroundColor: theme.palette.common.black,
    // color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

// eslint-disable-next-line no-unused-vars
export default function InvoiceTable({
  docs,
  page,
  setPage,
  itens,
  setItens,
  total,
  download,
}) {
  const classes = useStyles();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (docs) {
      const list = [];
      docs.forEach(d => {
        list.push(
          createData(
            d.invoice_number,
            d.order_number,
            d.amount,
            d.LegalEntity,
            d.payment_date,
            d.created_at,
          ),
        );
      });
      setRows(list);
    }
  }, [docs]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setItens(event.target.value);
  };

  return (
    <Paper className={classes.root}>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Notal Fiscal</StyledTableCell>
              <StyledTableCell>Nº do Pedido</StyledTableCell>
              <StyledTableCell>Valor</StyledTableCell>
              <StyledTableCell>Cliente</StyledTableCell>
              <StyledTableCell>Recebimento</StyledTableCell>
              <StyledTableCell align="right">
                <div style={{ display: 'flex', justifyContent: 'end' }}>
                  Emissão
                  <Tooltip title="Exportar para Excel" arrow>
                    <GetApp style={{ cursor: 'pointer' }} onClick={download} />
                  </Tooltip>
                </div>
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <StyledTableRow key={i}>
                  <StyledTableCell>{row.nf}</StyledTableCell>
                  <StyledTableCell>{row.order}</StyledTableCell>
                  <StyledTableCell>
                    {' '}
                    {new Intl.NumberFormat('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })
                      .format(row.value)
                      .replace(',', '.')}
                  </StyledTableCell>
                  <StyledTableCell>{row.client}</StyledTableCell>
                  <StyledTableCell>
                    {row.receiving &&
                      moment(row.receiving).format('DD/MM/YYYY')}
                  </StyledTableCell>
                  <StyledTableCell align="right">
                    {row.emit && moment(row.emit).format('DD/MM/YYYY')}
                  </StyledTableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100, 1000, 50000]}
        component="div"
        count={total}
        rowsPerPage={itens}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
